import {  CommonModule    } from '@angular/common';
import {  Component       ,
          Input           } from '@angular/core';
import {  TranslatePipe   } from 'nv@services/translate.service';

@Component({
  selector    : 'template-electricity-price',
  templateUrl : './template-electricity-price.component.html',
  imports     : [ CommonModule, TranslatePipe ]
})
export class TemplateElectricityPrice {

  @Input() public inputData: any;
  @Input() public inputIsVisible = false
}
